import type { CrmMessages } from "./englishCrmMessages";

export const russianCrmMessages = {
  resources: {
    companies: {
      name: "Компания |||| Компании",
      forcedCaseName: "Компания",
      fields: {
        name: "Название компании",
        website: "Сайт",
        linkedin_url: "LinkedIn",
        phone_number: "Телефон",
        created_at: "Дата создания",
        nb_contacts: "Количество контактов",
        revenue: "Выручка",
        sector: "Отрасль",
        size: "Размер",
        tax_identifier: "ИНН",
        address: "Адрес",
        city: "Город",
        zipcode: "Индекс",
        state_abbr: "Регион",
        country: "Страна",
        description: "Описание",
        context_links: "Полезные ссылки",
        sales_id: "Ответственный",
      },
      empty: {
        description: "Похоже, список компаний пока пуст.",
        title: "Компании не найдены",
      },
      field_categories: {
        contact: "Контакты",
        additional_info: "Дополнительная информация",
        address: "Адрес",
        context: "Контекст",
      },
      action: {
        create: "Создать компанию",
        edit: "Редактировать компанию",
        new: "Новая компания",
        show: "Открыть компанию",
      },
      added_on: "Добавлена %{date}",
      followed_by: "Ведет %{name}",
      followed_by_you: "Ведете вы",
      no_contacts: "Нет контактов",
      nb_contacts:
        "%{smart_count} контакт |||| %{smart_count} контакта |||| %{smart_count} контактов",
      nb_deals:
        "%{smart_count} сделка |||| %{smart_count} сделки |||| %{smart_count} сделок",
      sizes: {
        one_employee: "1 сотрудник",
        two_to_nine_employees: "2-9 сотрудников",
        ten_to_forty_nine_employees: "10-49 сотрудников",
        fifty_to_two_hundred_forty_nine_employees: "50-249 сотрудников",
        two_hundred_fifty_or_more_employees: "250 сотрудников и больше",
      },
      autocomplete: {
        create_error: "Не удалось создать компанию",
        create_item: "Создать %{item}",
        create_label: "Начните вводить, чтобы создать новую компанию",
      },
      filters: {
        only_mine: "Только компании, за которые я отвечаю",
      },
    },
    contacts: {
      name: "Контакт |||| Контакты",
      forcedCaseName: "Контакт",
      field_categories: {
        background_info: "Контекст",
        identity: "Личные данные",
        misc: "Разное",
        personal_info: "Контактные данные",
        position: "Должность",
      },
      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        last_seen: "Последняя активность",
        title: "Должность",
        company_id: "Компания",
        email_jsonb: "Email-адреса",
        email: "Email",
        phone_jsonb: "Телефоны",
        phone_number: "Телефон",
        telegram: "Telegram",
        source: "Источник",
        background: "Контекст: биография, где познакомились и т.п.",
        has_newsletter: "Подписан на рассылку",
        sales_id: "Ответственный",
      },
      action: {
        add: "Добавить контакт",
        add_first: "Добавьте первый контакт",
        create: "Создать контакт",
        edit: "Редактировать контакт",
        export_vcard: "Экспорт в vCard",
        new: "Новый контакт",
        show: "Открыть контакт",
      },
      background: {
        last_activity_on: "Последняя активность %{date}",
        added_on: "Добавлен %{date}",
        followed_by: "Ведет %{name}",
        followed_by_you: "Ведете вы",
        status_none: "Нет",
        source: "Источник: %{source}",
      },
      position_at: "%{title} в",
      position_at_company: "%{title} в %{company}",
      empty: {
        description: "Похоже, список контактов пока пуст.",
        title: "Контакты не найдены",
      },
      import: {
        title: "Импорт контактов",
        button: "Импорт CSV",
        complete:
          "Импорт завершен. Импортировано контактов: %{importCount}, ошибок: %{errorCount}",
        progress:
          "Импортировано %{importCount} из %{rowCount} контактов, ошибок: %{errorCount}.",
        error:
          "Не удалось импортировать файл. Проверьте, что это корректный CSV-файл.",
        imported: "Импортировано",
        remaining_time: "Оставшееся время:",
        running: "Идет импорт, не закрывайте эту вкладку.",
        sample_download: "Скачать пример CSV",
        sample_hint: "Пример CSV-файла, который можно использовать как шаблон",
        stop: "Остановить импорт",
        csv_file: "CSV-файл",
        contacts_label: "контакт |||| контакта |||| контактов",
      },
      inputs: {
        genders: {
          male: "Он",
          female: "Она",
          nonbinary: "Они",
        },
        personal_info_types: {
          work: "Рабочий",
          home: "Домашний",
          other: "Другой",
        },
      },
      list: {
        error_loading: "Ошибка загрузки контактов",
      },
      bulk_tag: {
        action: "Добавить тег",
        back: "Назад к тегам",
        create_description:
          "Создайте новый тег и примените его к выбранным контактам.",
        description:
          "Выберите существующий тег или создайте новый для выбранных контактов.",
        empty: "Тегов пока нет. Создайте тег для выбранных контактов.",
        error: "Не удалось добавить тег к контактам",
        noop: "У выбранных контактов уже есть этот тег",
        success:
          "Тег добавлен к %{smart_count} контакту |||| Тег добавлен к %{smart_count} контактам",
        title: "Добавить тег к контактам",
      },
      merge: {
        action: "Объединить с другим контактом",
        confirm: "Объединить контакты",
        current_contact: "Текущий контакт (будет удален)",
        description: "Объединить этот контакт с другим.",
        error: "Не удалось объединить контакты",
        merging: "Объединение...",
        no_additional_data: "Нет дополнительных данных для объединения",
        select_target: "Выберите контакт для объединения",
        success: "Контакты успешно объединены",
        target_contact: "Целевой контакт (будет сохранен)",
        title: "Объединить контакт",
        warning_description:
          "Все данные будут перенесены во второй контакт. Это действие нельзя отменить.",
        warning_title: "Внимание: необратимая операция",
        what_will_be_merged: "Что будет объединено:",
      },
      filters: {
        before_last_month: "До прошлого месяца",
        before_this_month: "До этого месяца",
        before_this_week: "До этой недели",
        managed_by_me: "Мои контакты",
        search: "Поиск по имени, компании...",
        this_week: "На этой неделе",
        today: "Сегодня",
        tags: "Теги",
        tasks: "Задачи",
      },
      hot: {
        empty_change_status:
          'Измените статус контакта, добавив заметку и нажав "показать параметры".',
        empty_hint: 'Контакты со статусом "горячий" появятся здесь.',
        title: "Горячие контакты",
      },
    },
    deals: {
      name: "Сделка |||| Сделки",
      fields: {
        name: "Название",
        description: "Описание",
        company_id: "Компания",
        contact_ids: "Контакты",
        category: "Категория",
        amount: "Бюджет",
        expected_closing_date: "Ожидаемая дата закрытия",
        stage: "Этап",
      },
      action: {
        back_to_deal: "Назад к сделке",
        create: "Создать сделку",
        new: "Новая сделка",
      },
      field_categories: {
        misc: "Разное",
      },
      archived: {
        action: "Архивировать",
        error: "Ошибка: сделка не архивирована",
        list_title: "Архивные сделки",
        success: "Сделка архивирована",
        title: "Архивная сделка",
        view: "Показать архивные сделки",
      },
      snoozed: {
        action: "Отложить",
        custom_label: "Выбрать дату",
        error: "Ошибка: не удалось отложить сделку",
        list_title: "Отложенные сделки",
        popover_title: "Не тревожить до",
        preset_month: "На месяц",
        preset_three_days: "Через 3 дня",
        preset_tomorrow: "До завтра",
        preset_week: "На неделю",
        success: "Сделка отложена",
        title: "Отложенная сделка",
        until_label: "до",
        view: "Показать отложенные",
      },
      unsnoozed: {
        action: "Вернуть из отложенных",
        error: "Ошибка: не удалось вернуть сделку",
        success: "Сделка возвращена на доску",
      },
      inputs: {
        linked_to: "Связано с",
      },
      unarchived: {
        action: "Вернуть на доску",
        error: "Ошибка: сделка не восстановлена из архива",
        success: "Сделка восстановлена из архива",
      },
      updated: "Сделка обновлена",
      empty: {
        before_create: "перед созданием сделки.",
        description: "Похоже, список сделок пока пуст.",
        title: "Сделки не найдены",
      },
      invalid_date: "Некорректная дата",
    },
    contracts: {
      name: "Договор |||| Договоры",
      forcedCaseName: "Договор",
      fields: {
        title: "Название договора",
        company_id: "Клиент",
        contact_id: "Контакт",
        deal_id: "Сделка",
        payment_type: "Тип оплаты",
        total_amount: "Общая сумма",
        monthly_amount: "Ежемесячный платеж",
        start_date: "Дата начала",
        end_date: "Дата окончания",
        status: "Статус",
        next_payment_date: "Следующий платеж",
        period: "Периодичность",
        payment_amount: "Сумма платежа",
        payment_schedule: "График платежей",
        notes: "Комментарий",
        attachments: "Вложения",
        sales_id: "Ответственный",
      },
      action: {
        new: "Новый договор",
        create_from_deal: "Создать договор из сделки",
      },
      empty: {
        title: "Договоров пока нет",
      },
      inputs: {
        payment_schedule_helper:
          "Можно указать JSON или текстовое описание графика. Реальные оплаты ведутся в платежах.",
      },
      payment_types: {
        subscription: "Подписка",
        installment: "Рассрочка",
        one_time: "Разовый платеж",
      },
      statuses: {
        active: "Активен",
        completed: "Завершен",
        overdue: "Просрочен",
        cancelled: "Отменен",
      },
    },
    payments: {
      name: "Запись |||| Планирование",
      forcedCaseName: "Запись",
      fields: {
        direction: "Направление",
        contract_id: "Договор",
        account_id: "Счёт",
        category_id: "Категория",
        vendor_name: "Плательщик / Получатель",
        recipient: "Контрагент",
        planned_date: "Плановая дата",
        paid_date: "Дата оплаты",
        amount: "Сумма",
        status: "Статус",
        comment: "Комментарий",
        reminder_sent_at: "Последнее напоминание",
        sales_id: "Ответственный",
      },
      action: {
        new: "Новая запись",
        duplicate: "Дублировать",
      },
      empty: {
        title: "Платежей пока нет",
      },
      filters: {
        due_soon: "Ожидаются скоро",
        overdue: "Просроченные",
        paid: "Оплаченные",
      },
      statuses: {
        pending: "Ожидается",
        paid: "Оплачен",
        overdue: "Просрочен",
      },
    },
    accounts: {
      name: "Счёт |||| Счета",
      forcedCaseName: "Счёт",
      fields: {
        name: "Название",
        type: "Тип",
        initial_balance: "Начальный баланс",
        currency: "Валюта",
        notes: "Заметки",
        current_balance: "Текущий баланс",
      },
      action: { new: "Новый счёт" },
      empty: { title: "Счетов пока нет" },
      types: {
        cash: "Наличные",
        bank: "Банк",
        card: "Карта",
        other: "Другое",
      },
    },
    transactions: {
      name: "Транзакция |||| Транзакции",
      forcedCaseName: "Транзакция",
      fields: {
        account_id: "Счёт",
        category_id: "Категория",
        direction: "Тип",
        amount: "Сумма",
        occurred_at: "Дата",
        description: "Описание",
        contract_id: "Договор",
        deal_id: "Сделка",
        company_id: "Компания",
        payment_id: "Платёж",
        sales_id: "Ответственный",
        attachments: "Вложения",
      },
      directions: {
        income: "Доход",
        expense: "Расход",
        transfer: "Перевод",
      },
      action: { new: "Новая транзакция", duplicate: "Дублировать" },
      empty: { title: "Транзакций нет" },
    },
    transaction_categories: {
      name: "Категория |||| Категории",
      forcedCaseName: "Категория",
      fields: {
        name: "Название",
        direction: "Тип",
        icon: "Иконка",
        color: "Цвет",
      },
      action: { new: "Новая категория" },
      empty: { title: "Категорий нет" },
    },
    transfers: {
      name: "Перевод |||| Переводы",
      forcedCaseName: "Перевод",
      fields: {
        from_account_id: "Со счёта",
        to_account_id: "На счёт",
        amount: "Сумма",
        occurred_at: "Дата",
        description: "Описание",
      },
      action: { new: "Новый перевод" },
      empty: { title: "Переводов нет" },
    },
    notes: {
      name: "Заметка |||| Заметки",
      forcedCaseName: "Заметка",
      fields: {
        status: "Статус",
        date: "Дата",
        attachments: "Вложения",
        contact_id: "Контакт",
        deal_id: "Сделка",
      },
      action: {
        add: "Добавить заметку",
        add_first: "Добавьте первую заметку",
        delete: "Удалить заметку",
        edit: "Редактировать заметку",
        update: "Обновить заметку",
        add_this: "Добавить эту заметку",
      },
      sheet: {
        create: "Создать заметку",
        create_for: "Создать заметку для %{name}",
        edit: "Редактировать заметку",
        edit_for: "Редактировать заметку для %{name}",
      },
      deleted: "Заметка удалена",
      empty: "Заметок пока нет",
      author_added: "%{name} добавил(а) заметку",
      you_added: "Вы добавили заметку",
      me: "Я",
      list: {
        error_loading: "Ошибка загрузки заметок",
      },
      note_for_contact: "Заметка для %{name}",
      stepper: {
        hint: "Откройте страницу контакта и добавьте заметку",
      },
      added: "Заметка добавлена",
      inputs: {
        add_note: "Добавить заметку",
        options_hint: "(прикрепить файлы или изменить детали)",
        show_options: "Показать параметры",
      },
      actions: {
        attach_document: "Прикрепить документ",
      },
      validation: {
        note_or_attachment_required: "Нужна заметка или вложение",
      },
    },
    sales: {
      name: "Пользователь |||| Пользователи",
      fields: {
        first_name: "Имя",
        last_name: "Фамилия",
        email: "Email",
        administrator: "Администратор",
        disabled: "Отключен",
      },
      create: {
        error: "Не удалось создать пользователя.",
        success:
          "Пользователь создан. Скоро он получит письмо для установки пароля.",
        title: "Создать нового пользователя",
      },
      edit: {
        error: "Произошла ошибка. Попробуйте еще раз.",
        record_not_found: "Запись не найдена",
        success: "Пользователь успешно обновлен",
        title: "Редактировать %{name}",
      },
      action: {
        new: "Новый пользователь",
      },
    },
    tasks: {
      name: "Задача |||| Задачи",
      forcedCaseName: "Задача",
      fields: {
        text: "Описание",
        due_date: "Срок",
        type: "Тип",
        contact_id: "Контакт",
        due_short: "срок",
      },
      action: {
        add: "Добавить задачу",
        create: "Создать задачу",
        edit: "Редактировать задачу",
      },
      actions: {
        postpone_next_week: "Перенести на следующую неделю",
        postpone_tomorrow: "Перенести на завтра",
        title: "действия с задачей",
      },
      added: "Задача добавлена",
      deleted: "Задача удалена",
      dialog: {
        create: "Создать задачу",
        create_for: "Создать задачу для %{name}",
      },
      sheet: {
        edit: "Редактировать задачу",
        edit_for: "Редактировать задачу для %{name}",
      },
      empty: "Задач пока нет",
      empty_list_hint: "Задачи, добавленные к контактам, появятся здесь.",
      filters: {
        later: "Позже",
        overdue: "Просроченные",
        this_week: "На этой неделе",
        today: "Сегодня",
        tomorrow: "Завтра",
        with_pending: "С активными задачами",
      },
      regarding_contact: "(по контакту: %{name})",
      updated: "Задача обновлена",
    },
    tags: {
      name: "Тег |||| Теги",
      action: {
        add: "Добавить тег",
        create: "Создать тег",
      },
      dialog: {
        color: "Цвет",
        create_title: "Создать новый тег",
        edit_title: "Редактировать тег",
        name_label: "Название тега",
        name_placeholder: "Введите название тега",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Сбросить пароль",
    },
    auth: {
      first_name: "Имя",
      last_name: "Фамилия",
      confirm_password: "Подтвердите пароль",
      confirmation_required:
        "Перейдите по ссылке, которую мы отправили на email, чтобы подтвердить аккаунт.",
      recovery_email_sent:
        "Если пользователь зарегистрирован, письмо для восстановления пароля скоро придет на email.",
      sign_in_failed: "Не удалось войти.",
      sign_in_google_workspace: "Войти через Google Workspace",
      sign_in_sso: "Войти через SSO",
      signup: {
        create_account: "Создать аккаунт",
        create_first_user:
          "Создайте первого пользователя, чтобы завершить настройку.",
        creating: "Создание...",
        initial_user_created: "Первый пользователь успешно создан",
      },
      welcome_title: "Добро пожаловать в Atomic CRM",
    },
    common: {
      activity: "Активность",
      added: "добавлено",
      details: "Детали",
      last_activity_with_date: "последняя активность %{date}",
      load_more: "Загрузить еще",
      misc: "Разное",
      past: "Прошедшие",
      read_more: "Показать больше",
      retry: "Повторить",
      show_less: "Скрыть",
      copied: "Скопировано",
      copy: "Копировать",
      loading: "Загрузка...",
      me: "Я",
      task_count:
        "%{smart_count} задача |||| %{smart_count} задачи |||| %{smart_count} задач",
    },
    activity: {
      added_company: "%{name} добавил(а) компанию",
      you_added_company: "Вы добавили компанию",
      added_contact: "%{name} добавил(а) контакт",
      you_added_contact: "Вы добавили контакт",
      added_note: "%{name} добавил(а) заметку о",
      you_added_note: "Вы добавили заметку о",
      added_note_about_deal: "%{name} добавил(а) заметку о сделке",
      you_added_note_about_deal: "Вы добавили заметку о сделке",
      added_deal: "%{name} добавил(а) сделку",
      you_added_deal: "Вы добавили сделку",
      at_company: "в",
      to: "к",
      load_more: "Загрузить еще активность",
    },
    dashboard: {
      deals_chart: "Ожидаемая выручка по сделкам",
      deals_pipeline: "Воронка сделок",
      latest_activity: "Последняя активность",
      latest_activity_error: "Ошибка загрузки последней активности",
      latest_notes: "Мои последние заметки",
      latest_notes_added_ago: "добавлено %{timeAgo}",
      stepper: {
        install: "Установить Atomic CRM",
        progress: "%{step}/3 выполнено",
        whats_next: "Что дальше?",
      },
      upcoming_tasks: "Предстоящие задачи",
    },
    header: {
      import_data: "Импорт данных",
    },
    image_editor: {
      change: "Изменить",
      drop_hint: "Перетащите файл сюда или нажмите, чтобы выбрать его.",
      editable_content: "Редактируемое содержимое",
      title: "Загрузить и обрезать изображение",
      update_image: "Обновить изображение",
    },
    import: {
      action: {
        download_error_report: "Скачать отчет об ошибках",
        import: "Импортировать",
        import_another: "Импортировать другой файл",
      },
      error: {
        unable: "Не удалось импортировать этот файл.",
      },
      idle: {
        description_1:
          "Можно импортировать пользователей, компании, контакты, заметки и задачи.",
        description_2:
          "Данные должны быть в JSON-файле, соответствующем примеру ниже:",
      },
      status: {
        all_success: "Все записи успешно импортированы.",
        complete: "Импорт завершен.",
        failed: "Ошибка",
        imported: "Импортировано",
        in_progress: "Идет импорт, не уходите с этой страницы.",
        some_failed: "Некоторые записи не были импортированы.",
        table_caption: "Статус импорта",
      },
      title: "Импорт данных",
    },
    settings: {
      companies: {
        sectors: "Отрасли",
      },
      dark_mode_logo: "Логотип для темной темы",
      deals: {
        categories: "Категории",
        currency: "Валюта",
        pipeline_help:
          "Выберите этапы сделок, которые должны учитываться в воронке.",
        pipeline_statuses: "Статусы воронки",
        stages: "Этапы",
      },
      light_mode_logo: "Логотип для светлой темы",
      notes: {
        statuses: "Статусы",
      },
      reset_defaults: "Сбросить к значениям по умолчанию",
      save_error: "Не удалось сохранить конфигурацию",
      saved: "Конфигурация сохранена",
      saving: "Сохранение...",
      tasks: {
        types: "Типы",
      },
      preferences: "Предпочтения",
      title: "Настройки",
      app_title: "Название приложения",
      sections: {
        branding: "Брендинг",
      },
      validation: {
        duplicate: "Дубликат %{display_name}: %{items}",
        in_use:
          "Нельзя удалить %{display_name}, которые еще используются в сделках: %{items}",
        validating: "Проверка...",
        entities: {
          categories: "категории",
          stages: "этапы",
        },
      },
    },
    theme: {
      dark: "Темная",
      label: "Тема",
      light: "Светлая",
      system: "Системная",
    },
    language: "Язык",
    navigation: {
      label: "Навигация CRM",
    },
    profile: {
      inbound: {
        description:
          "Можно отправлять письма на входящий email-адрес сервера, например добавив его в поле %{field}. Atomic CRM обработает письма и добавит заметки к соответствующим контактам.",
        title: "Входящая почта",
      },
      mcp: {
        title: "MCP-сервер",
        description:
          "Используйте этот URL, чтобы подключить AI-ассистента к данным CRM через Model Context Protocol (MCP).",
      },
      password: {
        change: "Изменить пароль",
      },
      password_reset_sent: "Письмо для сброса пароля отправлено на ваш email",
      record_not_found: "Запись не найдена",
      title: "Профиль",
      updated: "Профиль обновлен",
      update_error: "Произошла ошибка. Попробуйте еще раз",
    },
    validation: {
      invalid_url: "Введите корректный URL",
      invalid_linkedin_url: "URL должен быть с домена linkedin.com",
    },
  },
  finance: {
    balanceUnavailable: "—",
    dashboard: {
      title: "Финансы",
      cashflow: "Доходы/расходы по месяцам",
      quickLinks: "Разделы",
      addIncome: "Доход",
      addExpense: "Расход",
      addTransfer: "Перевод",
      noAccounts: "Создайте первый счёт",
      noData: "Нет данных",
    },
    iconPicker: {
      title: "Иконка категории",
      pick: "Выбрать",
    },
    markPaid: {
      action: "Принять оплату",
      actionExpense: "Провести выплату",
      title: "Принять оплату",
      titleExpense: "Провести выплату",
      account: "Счёт зачисления",
      accountExpense: "Счёт списания",
      category: "Категория",
      date: "Дата",
      description: "Описание",
      submit: "Принять",
      submitExpense: "Провести",
      success: "Операция проведена",
      accountRequired: "Выберите счёт",
      transactionLabel: "Связанная транзакция",
    },
    forecast: {
      title: "Прогноз — календарь планируемых движений",
      openPlanning: "Перейти в планирование",
      chartTitle: "Планируемые доходы/расходы по месяцам",
    },
    nav: {
      dashboard: "Дашборд",
      planning: "Планирование",
      categories: "Категории",
      accounts: "Счета",
      transactions: "Транзакции",
      transfers: "Переводы",
    },
  },
} satisfies CrmMessages;
